import { fetchGet } from '../service';
import { buildApiUrl } from '../../utils/build-api-url';
import type { IBookmarks, IResponse } from '../../types';

export async function getBookmarks(
  bookmarks: Array<{ group: string; id: string }>,
  pimLanguage: string,
  cmsNativeLanguage: string,
): Promise<IResponse<IBookmarks> | null> {
  const url = buildApiUrl('bookmarks', {
    pimLanguage,
    cmsNativeLanguage,
    bookmarks: bookmarks.map((item) => JSON.stringify(item)),
  });

  return fetchGet<IBookmarks>(url);
}
